// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.freight-cascader-multiple-cj1 .el-cascader-menu .el-checkbox {\n  display: none;\n}\n.freight-cascader-multiple-cj1 .el-cascader-menu .other-checkbox {\n  display: inline-block;\n}\n.freight-cascader-multiple-cj1 .el-cascader-menu .other-nodetext {\n  line-height: 35px;\n  padding: 0 10px;\n}\n", ""]);
// Exports
module.exports = exports;
